import { render, staticRenderFns } from "./DeviceRecordDetail.vue?vue&type=template&id=b3677c4a&"
import script from "./DeviceRecordDetail.vue?vue&type=script&lang=ts&"
export * from "./DeviceRecordDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports